import React, { useState } from "react";
import GenericModal from "../../../../components/buttons/genericModal";
import { backendPostWithoutRefresh } from "../../../../helpers/callBackend";
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';
import { errorMessage } from "../../../../helpers/errorMessageFunc";
import TxtUpload from "../../../../components/imports/txtUpload";
import LoadingButton from "@mui/lab/LoadingButton";

const UploadSFTPFilesModal = (props) => {
    const [visible, setVisible] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]);

    const onFormSubmitModal = () => {
        setSubmitting(true);
        if (uploadedFiles.length === 0) {
            return errorMessage("Please upload at least one file");
        }
        backendPostWithoutRefresh(
            "/api/sftp/file-copy/",
            { files: uploadedFiles, server_id: props.sftpServerId }
        ).then((res) => {
            if (res?.data?.data) {
                props.onUploadSuccess(res?.data?.data);
            }
            setSubmitting(false);
        }).catch(() => {
            setSubmitting(false);
        })
    }

    return (
        <GenericModal
            visible={visible}
            handleCancelModal={() => {
                setVisible(false);
                setSubmitting(false);
            }}
            showModal={() => {
                if (props.loading) return;
                setVisible(true);
                setSubmitting(false);
            }}
            size='md'
            button={
                <Button
                    disableElevation fullWidth variant="contained" color="primary"
                    sx={{ fontSize: 14, width: '100%', textTransform: 'none', marginBottom: "8px" }}
                    disabled={props.loading}
                >
                    Upload Files
                </Button>
            }
            modalTitle={'Upload Files'}
            modalBody={
                <>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                        Please upload BAI2 files for {props.bankName} below. Your files should be .txt files matching the expected naming convention.
                    </Typography>
                    <TxtUpload txtData={uploadedFiles} setTxtData={setUploadedFiles} />
                    <LoadingButton
                        loadingPosition="start" disableElevation fullWidth variant="contained"
                        color="primary" sx={{ mt: 2, fontSize: 14, width: '100px', textTransform: 'none' }}
                        loading={submitting} onClick={onFormSubmitModal}
                    > Submit </LoadingButton>
                </>
            }
        />
    );
};

export default UploadSFTPFilesModal;
